import * as React from "react";
import { forwardRef } from "react";
const SvgUae = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 36 36", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#068241", d: "M32 5H9v9h27V9c0-2.209-1.791-4-4-4z" }), /* @__PURE__ */ React.createElement("path", { fill: "#EEE", d: "M9 14h27v8H9z" }), /* @__PURE__ */ React.createElement("path", { fill: "#141414", d: "M9 31h23c2.209 0 4-1.791 4-4v-5H9v9z" }), /* @__PURE__ */ React.createElement("path", { fill: "#EC2028", d: "M4 5C1.791 5 0 6.791 0 9v18c0 2.209 1.791 4 4 4h5V5H4z" }));
const ForwardRef = forwardRef(SvgUae);
export default ForwardRef;
